<template>
  <div>
    <Head :title="`${data.id}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ data.id }}
    </h1>
    <div class="grid gap-4 lg:grid-cols-2 grid-cols-1">
      <detail-view :data="detailView" />
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import DetailView from '@/Shared/DetailView'

export default {
  components: {
    DetailView,
    Head,
    Link,
  },
  layout: Layout,
  props: {
    data: Object,
  },
  data() {
    return {
      detailView: {
        items: [
          // {label: this.$t('justiceworkers.type'), value: this.data.type_name},
          {label: this.$t('justiceworkers.name'), value: this.data.name},
          {label: this.$t('justiceworkers.function'), value: this.data.function},
          {label: this.$t('justiceworkers.date'), value: this.$filters.formatDate(this.data.date)},
          {label: this.$t('justiceworkers.note'), value: this.data.note},
        ],
        updateLink: `/applicants/${this.data.applicant_details.id}/justice-workers/${this.data.id}/edit/`,
        header: {
          title: this.$t('applicants.situation_case'),
          text: '',
        },
      },
    }
  },
}
</script>
